import Results from './Results.container';

export default Results;



// WEBPACK FOOTER //
// ./src/ui/interaction/children/quiz/children/results/index.js